import passageInstruction from '../spanish/clpl_passage_instructions.json';
import directionInstruction from '../spanish/clpl_direction.json';
import clickOk from '../spanish/clpl_click_ok.json';
import scrollIntroInstruction from '../spanish/clpl_scroll_intro.json';
import scrollDownInstruction from '../spanish/clpl_scroll_down.json';
import scrollReadyInstruction from '../spanish/clpl_ready.json';
import scrollInstruction from '../spanish/clpl_ready_instructions.json';
import scrollReadyClickOk from '../spanish/clpl_ready_click_ok.json';
import modelCorrectResponse from '../spanish/clpl_model_correct_answer_selected.json';
import modelIncorrectResponse from '../spanish/clpl_model_incorrect_answer_selected.json';
import modelSecondIncorrectResponse from '../spanish/clpl_model_incorrect_answer_selected_twice.json';
import modelInstructionStart from '../spanish/clpl_model_sentence_start.json';
import modelInstructionEnd from '../spanish/clpl_model_sentence_end.json';
import modelOptionOne from '../spanish/clpl_model_option_one.json';
import modelOptionTwo from '../spanish/clpl_model_option_two.json';
import modelOptionThree from '../spanish/clpl_model_option_three.json';
import practiceIntro from '../spanish/clpl_practice_intro.json';
import practiceEnd from '../spanish/clpl_practice_sentence_end.json';
import practiceOptionOne from '../spanish/clpl_practice_option_one.json';
import practiceOptionTwo from '../spanish/clpl_practice_option_two.json';
import practiceOptionThree from '../spanish/clpl_practice_option_three.json';
import practiceCorrectAnswerSelected from '../spanish/clpl_practice_correct_answer_selected.json';
import practiceIncorrectAnswerSelected from '../spanish/clpl_practice_incorrect_answer_selected.json';
import practiceIncorrectAnswerSelectedTwice from '../spanish/clpl_practice_incorrect_answer_selected_twice.json';
import { MODEL, PRACTICE, SCROLL } from '../../constants/assessmentItemType';
import CLPL_INSTRUCTIONS from '../../clpl/clplConstants';

const CLPL_CAPTIONS = {
    [CLPL_INSTRUCTIONS.passageInstruction]: passageInstruction,
    [CLPL_INSTRUCTIONS[MODEL].directionInstruction]: directionInstruction,
    [CLPL_INSTRUCTIONS[MODEL].modelCorrectResponse]: modelCorrectResponse,
    [CLPL_INSTRUCTIONS[MODEL].modelIncorrectResponse]: modelIncorrectResponse,
    [CLPL_INSTRUCTIONS[MODEL].modelSecondIncorrectResponse]: modelSecondIncorrectResponse,
    [CLPL_INSTRUCTIONS[MODEL].modelInstructionStart]: modelInstructionStart,
    [CLPL_INSTRUCTIONS[MODEL].modelInstructionEnd]: modelInstructionEnd,
    [CLPL_INSTRUCTIONS[MODEL].modelOptionOne]: modelOptionOne,
    [CLPL_INSTRUCTIONS[MODEL].modelOptionTwo]: modelOptionTwo,
    [CLPL_INSTRUCTIONS[MODEL].modelOptionThree]: modelOptionThree,
    [CLPL_INSTRUCTIONS[MODEL].clickOk]: clickOk,
    [CLPL_INSTRUCTIONS[PRACTICE].practiceIntro]: practiceIntro,
    [CLPL_INSTRUCTIONS[PRACTICE].practiceEnd]: practiceEnd,
    [CLPL_INSTRUCTIONS[PRACTICE].practiceOptionOne]: practiceOptionOne,
    [CLPL_INSTRUCTIONS[PRACTICE].practiceOptionTwo]: practiceOptionTwo,
    [CLPL_INSTRUCTIONS[PRACTICE].practiceOptionThree]: practiceOptionThree,
    [CLPL_INSTRUCTIONS[PRACTICE].practiceCorrectAnswerSelected]: practiceCorrectAnswerSelected,
    [CLPL_INSTRUCTIONS[PRACTICE].practiceIncorrectAnswerSelected]: practiceIncorrectAnswerSelected,
    [CLPL_INSTRUCTIONS[PRACTICE]
        .practiceIncorrectAnswerSelectedTwice]: practiceIncorrectAnswerSelectedTwice,
    [CLPL_INSTRUCTIONS[PRACTICE].clickOk]: clickOk,
    [CLPL_INSTRUCTIONS[SCROLL].scrollIntroInstruction]: scrollIntroInstruction,
    [CLPL_INSTRUCTIONS[SCROLL].scrollDownInstruction]: scrollDownInstruction,
    [CLPL_INSTRUCTIONS[SCROLL].scrollReadyInstruction]: scrollReadyInstruction,
    [CLPL_INSTRUCTIONS[SCROLL].scrollInstruction]: scrollInstruction,
    [CLPL_INSTRUCTIONS[SCROLL].scrollReadyClickOk]: scrollReadyClickOk,
    [CLPL_INSTRUCTIONS[SCROLL].clickOk]: clickOk,
};

export default CLPL_CAPTIONS;
